import React from 'react';
import { Box, Typography } from '@mui/material';
import { CoverageDot } from './planning-order-card';

export function CoverageLegend() {
    return (
        <Box sx={{ mb: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    columnGap: 3,
                    rowGap: 0.5,
                }}
            >
                <Typography
                    variant={'caption'}
                    color={'text.secondary'}
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <CoverageDot coverage={'full'} />
                    &nbsp;Inventario cubre lo restante
                </Typography>
                <Typography
                    variant={'caption'}
                    color={'text.secondary'}
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <CoverageDot coverage={'partial'} />
                    &nbsp;Cubre parcialmente
                </Typography>
                <Typography
                    variant={'caption'}
                    color={'text.secondary'}
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <CoverageDot coverage={'none'} />
                    &nbsp;Sin inventario — producir
                </Typography>
            </Box>
            {/* The one thing that makes "Inv" readable: it is not the warehouse
                count. Pedidos consume the stock in the order shown, so the same
                product reads lower further down the board — which looks like an
                error until it is said out loud. */}
            <Typography
                variant={'caption'}
                color={'text.secondary'}
                sx={{ display: 'block', mt: 0.5 }}
            >
                &quot;Inv&quot; es el inventario que queda para ese pedido: los
                pedidos de arriba consumen primero, así que un mismo producto
                aparece con menos disponible conforme se baja en el tablero.
                Pasa el cursor sobre la cifra para ver el desglose.
            </Typography>
        </Box>
    );
}
